import {Component, OnInit} from '@angular/core';
import {provideRouter, RouterLinkActive, RouterOutlet} from '@angular/router';
import { RouterLink } from "@angular/router";
import {ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {AppPersonaComponent} from "./app-persona/app-persona.component";
import {TopBarComponent} from "./top-bar/top-bar.component";
import {HeaderDashboardComponent} from "./app-mkt/dashboard-mkt/header-dashboard/header-dashboard.component";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptor} from "./auth/auth.interceptor";



@Component({
  selector: 'app-root',
  standalone: true,
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
  ],
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    CommonModule,
    AppPersonaComponent,
    TopBarComponent,
    ReactiveFormsModule,
    HeaderDashboardComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {


  title = 'medilinkWeb';

}
